import { useState } from 'react'

import { Tabs, TabsProps } from 'antd'

import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'

import { AnnouncementType } from '@eastcoal/shared/enums/AnnouncementType'

import { AnnouncementList } from '../../../../components/AnnouncementList'
import { APPLY_ANNOUNCEMENT_LIST_PAGE_PATH } from '../../../Content/Announcement/Apply/constants/path'
import { TRANSACTION_ANNOUNCEMENT_LIST_PAGE_PATH } from '../../../Content/Announcement/Transaction/constants/path'

const AnnouncementTypePathMap: Record<string, string> = {
  [AnnouncementType.APPLY]: APPLY_ANNOUNCEMENT_LIST_PAGE_PATH,
  [AnnouncementType.TRANSACTION]: TRANSACTION_ANNOUNCEMENT_LIST_PAGE_PATH
}

export const AnnouncementTabs = () => {
  const [activeKey, setActiveKey] = useState(`${AnnouncementType.APPLY}`)
  const items: TabsProps['items'] = [
    {
      key: `${AnnouncementType.APPLY}`,
      label: '竞价预告',
      children: (
        <AnnouncementList defaultPageSize={7} type={AnnouncementType.APPLY} />
      )
    },
    {
      key: `${AnnouncementType.TRANSACTION}`,
      label: '成交公告',
      children: (
        <AnnouncementList
          defaultPageSize={7}
          type={AnnouncementType.TRANSACTION}
        />
      )
    }
  ]

  return (
    <Tabs
      activeKey={activeKey}
      items={items}
      type='card'
      tabBarExtraContent={
        <NavigateButton newtab to={AnnouncementTypePathMap[activeKey]}>
          更多&gt;
        </NavigateButton>
      }
      onTabClick={setActiveKey}
    />
  )
}
